// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__Zdz\\+G {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 25px 80px 80px;

  @media (max-width: 1024px) {
    padding: 20px;
  }
}

.style_header__B9Cc3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 25px;
}

.style_title__Gmv3L {
  display: flex;
  align-items: center;
  gap: 5px;

  @media (max-width: 500px) {
    display: block;
    font-size: 1.2rem;

    /* Apply font size to child Typography elements */
    & h5 {
      font-size: 1.2rem !important;
    }
  }
}

.style_searchHeader__UhyPD {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  width: 100%;
  gap: 1rem;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
}

.style_counter__QpkTq {
  display: flex;
  flex-direction: column;
}

.style_searchBox__kh210 {
  flex-shrink: 0;

  @media (max-width: 900px) {
    width: 100% !important;
    max-width: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SpecificGroup/style.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;;EAEvB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER;IACE,cAAc;IACd,iBAAiB;;IAEjB,iDAAiD;IACjD;MACE,4BAA4B;IAC9B;EACF;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,SAAS;;EAET;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;;EAEd;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: 25px 80px 80px;\n\n  @media (max-width: 1024px) {\n    padding: 20px;\n  }\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 25px;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  @media (max-width: 500px) {\n    display: block;\n    font-size: 1.2rem;\n\n    /* Apply font size to child Typography elements */\n    & h5 {\n      font-size: 1.2rem !important;\n    }\n  }\n}\n\n.searchHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  width: 100%;\n  gap: 1rem;\n\n  @media (max-width: 900px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.counter {\n  display: flex;\n  flex-direction: column;\n}\n\n.searchBox {\n  flex-shrink: 0;\n\n  @media (max-width: 900px) {\n    width: 100% !important;\n    max-width: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__Zdz+G`,
	"header": `style_header__B9Cc3`,
	"title": `style_title__Gmv3L`,
	"searchHeader": `style_searchHeader__UhyPD`,
	"counter": `style_counter__QpkTq`,
	"searchBox": `style_searchBox__kh210`
};
export default ___CSS_LOADER_EXPORT___;
